import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import { IntegrationsOutletContext } from "../types";

export const useLayoutHeading = (heading: string) => {
  const { setLayoutHeading } = useOutletContext<IntegrationsOutletContext>();

  useEffect(() => {
    if (!heading) {
      setLayoutHeading("");
    } else {
      setLayoutHeading(heading);
    }

    return () => {
      setLayoutHeading("");
    };
  }, [heading, setLayoutHeading]);
};
